import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import background from 'assets/background.png'

export default styled.div`
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: url(${background});
    background-blend-mode: overlay;
    background-position: bottom right;
    background-repeat: no-repeat;
    padding: 1rem 0rem;

    &__logo {
      height: 4rem;
      margin-left: 2rem;
    }

    &__list {
      li {
        transition: 0.1s all ease-in;

        &:hover {
          transform: translateX(1rem) scale(1.1);
        }
      }
    }

    &__content {
      display: flex;
      align-items: center;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      margin-left: 4rem;
    }
  }

  .top_menu {
    display: flex;
    justify-content: flex-end;
    padding-right: 2rem;
  }

  .content {
    margin: 2rem;
  }
`

export const CustomNavLink = styled(NavLink)`
  font-size: 1.4rem;
  color: #1d2d72;

  text-decoration: none;
  display: inline-block;
  padding: 2rem 1rem;

  &:hover {
    background-color: #eeeeee;
    border-radius: 8px;
  }

  &.active {
    font-weight: 600;
    background-color: #eeeeee;
    border-radius: 8px;
  }

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 0.5rem;
    vertical-align: text-bottom;
  }
`

export const TopMenuItem = styled.button`
  background-color: transparent;
  border: 0;
  outline: none;
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1d2d72;
  margin-left: 3rem;
  cursor: pointer;

  svg {
    vertical-align: middle;
  }
`
